module.exports = "/assets/a4b95b7689d65ef08975f129651a8495.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/W3.png
// module id = 1946
// module chunks = 0